import * as React from 'react';
import { ExternalLink } from '@volkswagen-onehub/icons-core';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledExternalLinkIndicator = styled(ExternalLink).withConfig({ displayName: "StyledExternalLinkIndicator", componentId: "sc-1wpzb1v" }) `border:0;width:0.85em;height:0.7em;${(props) => props.theme.direction === 'rtl' && `transform: scale(-1, 1);`}`;
export const ExternalLinkIndicator = (props) => {
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledExternalLinkIndicator, Object.assign({ variant: "default" }, (props.title ? { title: props.title } : { 'aria-hidden': true }), commonProps)));
};
